var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SharedGroupItem',{attrs:{"workflow":_vm.workflow,"nestedLevelIndex":0,"group":_vm.everyoneGroup,"usersSharedData":_vm.usersSharedData,"hideVisibilityStatus":_vm.hideVisibilityStatus,"sharedData":[_vm.everyoneSharedData, ..._vm.groupsSharedData]}})
}
var staticRenderFns = []

export { render, staticRenderFns }